// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_0cbaba7d8a--wrapper--jGZfR","text":"_0cbaba7d8a--text--LMbPE","button":"_0cbaba7d8a--button--qAkIb"};